const ImageDefaultFooter = () => null;

export default ImageDefaultFooter;
